import { useEffect } from 'react';
import Link from './link';
import Config from '../config.js';
function Header() {

  useEffect(() => {
    document.title = Config.SiteName;
  }, []);

  return (
    <div id='header'>
      <div className='container'>
        <h1 className='logo'>{Config.SiteName}</h1>
        <div className='navi'>
          {Config.Navi.map((item, index) => (
            <Link key={index} to={item.url} text={item.text} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Header;
